import ActionButton from 'components/common/ActionButton';
import FalconCardHeader from 'components/common/FalconCardHeader';
import IconButton from 'components/common/IconButton';
import React, { useEffect, useState } from 'react';
import { Card, Table } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { getAllDashboards } from 'services/dashboardService';
import CreateModal from '../CreateModal';

/***
 * Page showing the list of available dashboards
 * This page is used to create new dashboards and view/edit existing dashboards.
 */
export default function DashboardList() {
  const navigate = useNavigate();
  const [createModalShow, setCreateModalShow] = React.useState(false);
  const [myDashboards, setMyDashboards] = useState([]);

  // const loadData = () => {};
  useEffect(() => {
    getAllDashboards()
      .then(res => {
        setMyDashboards(res.data);
      })
      .catch(err => {
        console.log('Error loading data', err);
      });
  }, []);

  return (
    <>
    {/* Create Modal for creating new dashboards */}
      <CreateModal
        title="Create New Dashboard"
        endpoint="/dashboard/dashboard/"
        redirect="/dashboard/edit/"
        show={createModalShow}
        onHide={() => {
          setCreateModalShow(false);
        }}
      ></CreateModal>

      <Card className="p-0">
        <FalconCardHeader
          title="Dashboard List"
          light
          titleTag="h4"
          endEl={
            <IconButton
              size="sm"
              variant="falcon-primary"
              iconClassName="me-2"
              icon="plus"
              onClick={() => {
                setCreateModalShow(true);
              }}
            >
              Create New Dashboard
            </IconButton>
          }
        />

        <Card.Body className="p-0">
          {myDashboards.length == 0 ? (
            <div className="text-center">No dashboards to show.</div>
          ) : (
            <Table responsive size="sm" bordered>
              <thead>
                <tr>
                  <th scope="col">Name</th>
                  <th className="text-end" scope="col">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {myDashboards.map((dashboard, index) => (
                  <tr key={index}>
                    <td>
                      <a
                        href={`/dashboard/view/${dashboard.id}`}
                        target="_blank"
                        rel="noreferrer" 
                      >
                        {dashboard.name}
                      </a>
                    </td>
                    <td className="text-end">
                      <ActionButton
                        icon="eye"
                        title="View"
                        variant="action"
                        className="p-0 me-2"
                        onClick={() => {
                          navigate(`/dashboard/view/${dashboard.id}`);
                        }}
                      />
                      <ActionButton
                        icon="edit"
                        title="Edit"
                        variant="action"
                        className="p-0 me-2"
                        onClick={() => {
                          navigate(`/dashboard/edit/${dashboard.id}`);
                        }}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Card.Body>
      </Card>
    </>
  );
}
